import axios from "axios";
import { ServerSideTypes } from "../../operation/component/common/OperationCommonTypes";

export interface IFilter {
  type?: string;
}

const RsExportService = {
  network: {
    repairshop: {
      get: {
        asyncExport: (filters: IFilter, serverParams: ServerSideTypes.IParams) => {
          return axios
            .get("/network/repair-shop/asyncexport", {
              params: {
                ...filters,
                ...serverParams,
              },
            })
            .then((response) => response.data);
        },
    
        asyncExportById: (id: number) => {
          return axios.get(`/network/repair-shop/asyncexport/${id}/file`, {
            responseType: "arraybuffer",
            headers: { "Access-Control-Allow-Origin": true },
          });
        },
      },
    },
  },
};

export default RsExportService;
